export default "__VITE_ASSET__BwQuPZ75__"